var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"form-group-wrap",on:{"submit":function($event){$event.preventDefault();}}},[_vm._t("default",null,null,_vm.customRules())],2)}
var staticRenderFns = []

export { render, staticRenderFns }